var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23024D",
    d: "m10.81 5.323 5.143 3.251v-6.64zM.7 1.935v6.64l5.142-3.252zM15 0H1.65a.94.94 0 0 0-.924.811l7.599 5.007L15.925.811A.94.94 0 0 0 15 0M9.944 5.894l-1.35.888a.48.48 0 0 1-.524 0l-1.349-.89L.735 9.68a.94.94 0 0 0 .923.804h13.349a.94.94 0 0 0 .923-.804z"
  })));
};
export default SvgEmail;